import CheckboxMui from "@mui/material/Checkbox"

const Checkbox = ({ checked, onClick }) => {
  return (
    <CheckboxMui
      checked={checked}
      onClick={onClick}
      sx={{
        padding: 0,
        color: "#D4D4D4",
        "&.Mui-checked": {
          color: "#7FB1E3",
        },
      }}
    />
  )
}

export default Checkbox
